import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Icon } from "@/components/Icon";
import { ApiError } from "@/lib/api";

// A page that is not there (H-g03) — the same words for one that is someone else's, so the portal never
// says what exists — and a failure at Willems (H-g05), with the code to quote.

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="wl-empty" data-screen-label="Portaal Geen toegang">
      <div className="wl-empty__icon">
        <Icon name="search" size={20} />
      </div>
      <div className="wl-empty__title">{t("problem.notFound")}</div>
      <p className="wl-empty__text">{t("problem.notFoundText")}</p>
      <Link to="/shipments" className="wl-btn wl-btn--secondary">
        {t("problem.toShipments")}
      </Link>
    </div>
  );
}

export function Failure({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { t } = useTranslation();
  const code = error instanceof ApiError ? error.correlationId : null;
  return (
    <div className="wl-empty" data-screen-label="Portaal Serverfout">
      <div className="wl-empty__icon">
        <Icon name="alert" size={20} />
      </div>
      <div className="wl-empty__title">{t("problem.failure")}</div>
      <p className="wl-empty__text">
        {code ? t("problem.failureCode", { code: code.slice(0, 12).toUpperCase() }) : t("problem.failureText")}
      </p>
      <button type="button" className="wl-btn wl-btn--secondary" onClick={onRetry ?? (() => window.location.reload())}>
        <Icon name="refresh" />
        {t("problem.retry")}
      </button>
    </div>
  );
}
